// extracted by mini-css-extract-plugin
export default {"customLabel":"ListVariationsValuesItem_customLabel__OM8KA","checked":"ListVariationsValuesItem_checked__sEUlE","limit":"ListVariationsValuesItem_limit__M4MB9"};